import { commonjsGlobal as e } from "./main53.js";
var r, o;
function t() {
  if (o) return r;
  o = 1;
  var a = typeof e == "object" && e && e.Object === Object && e;
  return r = a, r;
}
export {
  t as __require
};
